import httpClient from "./httpClient";

const MemberBadgeService = {
  async getBadge(memberId) {
    const response = await httpClient.get(`/member/${memberId}/badge`);
    return response.data;
  },

  // Issues (or reissues, revoking any prior active badge) a new badge. The response's
  // plaintext `code`/`qrDataUrl` are only ever returned here — the code is hashed at
  // rest and can never be retrieved again after this call.
  async issueBadge(memberId) {
    const response = await httpClient.post(`/member/${memberId}/badge`);
    return response.data;
  },

  async revokeBadge(memberId, reason) {
    return await httpClient.post(`/member/${memberId}/badge/revoke`, { reason });
  },
};

export default MemberBadgeService;
